<template>
    <pagination v-model="pagination_data.current_page" :records="total_rows" :per-page="pagination_data.rows_per_page" @paginate="paginationCallback($event)" :options="options" />
</template>

<script>
import { shallowRef } from 'vue'

import Pagination from 'v-pagination-3';
import PaginationDesign from '@/ecom/components/pagination/PaginationDesign.vue';

const paginationTheme = shallowRef(PaginationDesign);

export default {
    emits: ["paginationClickListener"],
    props: ['total_rows', 'name', 'pagination_data', 'preserve_filters'],
    components: {Pagination, PaginationDesign},
    data() {
        return {
            options : {
                chunk : 5,
                chunksNavigation : 'scroll',
                edgeNavigation : true,
                template : paginationTheme
            }
        }    
    },
    methods : {
        paginationCallback(current_page_number){

            let starting_row_number = 0;

            if (current_page_number != 1){
                starting_row_number = (this.pagination_data.rows_per_page * (current_page_number-1));
            }

            let ending_row_number = starting_row_number + this.pagination_data.rows_per_page;
            
            this.$emit('paginationClickListener', this.name, current_page_number, starting_row_number, ending_row_number);
        }
    },
    mounted(){
        if (this.preserve_filters){
            this.options.chunksNavigation = 'fixed';
        }
    }
}
</script>